export const INVOICE_SET_DATE = 'INVOICE_SET_DATE';
export const INVOICE_SET_CLINIC = 'INVOICE_SET_CLINIC';
export const INVOICE_SET_CLINICS = 'INVOICE_SET_CLINICS';
export const INVOICE_GET_CLINICS = 'INVOICE_GET_CLINICS';
export const INVOICE_GET_PURCHASE_LOCATIONS = 'INVOICE_GET_PURCHASE_LOCATIONS';
export const INVOICE_SET_PURCHASE_LOCATION = 'INVOICE_SET_PURCHASE_LOCATION';
export const INVOICE_PRODUCTS_LOADING = 'INVOICE_PRODUCTS_LOADING';
export const INVOICE_GET_PRODUCTS = 'INVOICE_GET_PRODUCTS';
export const INVOICE_SET_RECEIPT_ERROR = 'INVOICE_SET_RECEIPT_ERROR';
export const INVOICE_UPDATE_LINE_ITEMS = 'INVOICE_UPDATE_LINE_ITEMS';
export const INVOICE_IS_SUBMITTING = 'INVOICE_IS_SUBMITTING';
export const INVOICE_VERIFICATION_SUCCESS = 'INVOICE_VERIFICATION_SUCCESS';
export const INVOICE_UPDATE_PROMO_CODES = 'INVOICE_UPDATE_PROMO_CODES';
export const INVOICE_CLEAR = 'INVOICE_CLEAR';
export const INVOICE_ERROR = 'INVOICE_ERROR';
export const INVOICE_SAVE_USER = 'INVOICE_SAVE_USER';
export const INVOICE_SET_SUCCESS_MESSAGE = 'INVOICE_SET_SUCCESS_MESSAGE';

export const INVOICE_SET_TRANSACTION_ID = 'INVOICE_SET_TRANSACTION_ID';
export const INVOICE_SET_RECEIPT_TO_BE_REPLACED = 'INVOICE_SET_RECEIPT_TO_BE_REPLACED';
export const INVOICE_SET_RECEIPTS = 'INVOICE_SET_RECEIPTS';
export const INVOICE_SET_RECEIPTS_LOADING = 'INVOICE_SET_RECEIPTS_LOADING';
export const INVOICE_REMOVE_RECEIPT = 'INVOICE_REMOVE_RECEIPT';
